module.exports = __webpack_public_path__ + "static/11500-top-image-no-figure-84483f9c37480bb798cc7e39e61d8cf0.jpg";